import { render, staticRenderFns } from "./SalaryInquiriesCards.vue?vue&type=template&id=2b8ec8ec&"
import script from "./SalaryInquiriesCards.vue?vue&type=script&lang=js&"
export * from "./SalaryInquiriesCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports